import { render, staticRenderFns } from "./Ancien.vue?vue&type=template&id=5d892714&scoped=true"
import script from "./Ancien.vue?vue&type=script&lang=js"
export * from "./Ancien.vue?vue&type=script&lang=js"
import style0 from "./Ancien.vue?vue&type=style&index=0&id=5d892714&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d892714",
  null
  
)

export default component.exports